import { render, staticRenderFns } from "./deliver.vue?vue&type=template&id=4f887c48&scoped=true&"
import script from "./deliver.vue?vue&type=script&lang=js&"
export * from "./deliver.vue?vue&type=script&lang=js&"
import style0 from "./deliver.vue?vue&type=style&index=0&id=4f887c48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f887c48",
  null
  
)

export default component.exports